// extracted by mini-css-extract-plugin
module.exports = {"main":"ChatBubble_main__7oFw5","message":"ChatBubble_message__1o2Ig","sender":"ChatBubble_sender__49YO-","date_wrap":"ChatBubble_date_wrap__2v7-Z"};